import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { debounce } from 'lodash';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';

// Suppress "ResizeObserver loop completed with undelivered notifications" warning
if (typeof window !== 'undefined') {
  const suppressResizeObserverError = () => {
    const handler = (event) => {
      if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', handler);
    return () => window.removeEventListener('error', handler);
  };

  suppressResizeObserverError();
}

// Add ResizeObserver logic
document.addEventListener('DOMContentLoaded', () => {
  const resizeElement = document.querySelector('.resizable-element'); // Replace with your selector

  if (resizeElement) {
    const handleResize = debounce((entries) => {
      entries.forEach((entry) => {
        console.log('Element resized:', entry.contentRect);
      });
    }, 200);

    const observer = new ResizeObserver(handleResize);
    observer.observe(resizeElement);

    window.addEventListener('beforeunload', () => {
      observer.disconnect();
    });
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

reportWebVitals(console.log);